/* eslint consistent-return: 0 */
// CHECK STATUS AND RETURN
export default function(response) {
  if (response.status === 200) {
    return response;
  }

  throw new Error('Bad request');
}
